<template>
	<div>
        <div class="row">
            <el-card class="pb-0 pt-0" shadow="always" :body-style="{ padding: '0px'}" style="width:100%;">
             
                <div class="row p-0" :style="'background-image: url(' + require('@/assets/img/bg_kinerja_keuangan_end.png') + ');background-size: 100% 100%;background-repeat: no-repeat;'">
                    <div class="row" style="margin-top:95px;">
                        <div class="col-md-6">
                            <el-button size="mini" @click="$router.push('/performance-report/realisasi-capex')"><i class="fa fa-angle-left"></i></el-button>
                        </div>
                        <div class="col-md-6 text-right">
                            <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        </div>
                    </div>

                    
                    <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
                    <br><br><br><br><br>
                </div>

            </el-card>
    </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'

export default
{
	extends: KinerjaKeuangan,
	components: { 
		//ReportParamSelect,
        //'editor': Editor,
	},

	data() {
		return {
            //activeName: 'first',
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');

    },
    methods: {
        
    },
}
</script>